import { generalAlertError } from '../../common/utils/alerts';
import caller from './formsBackofficeSlice';
import { quotationsBackofficeAxe } from '../../services/axios-client/quotationsBackofficeAxeClient';

const getFormData = () => quotationsBackofficeAxe.get('/form-data/service-models');

const getMunicipalities = () => quotationsBackofficeAxe.get('/form-data/communes');

const getPrivacyTerms = () => quotationsBackofficeAxe.get('/form-data/data-privacy');

const getVehicleBrands = () => quotationsBackofficeAxe.get('/form-data/vehicle-makes');

const getMotoBrands = () => quotationsBackofficeAxe.get('/form-data/get-moto-brands');

const getStates = () => quotationsBackofficeAxe.get('/form-data/states');

const backOfficeGetStates = () => quotationsBackofficeAxe.get('/form-data/states');
const backOfficeGetVehicleBrands = () => quotationsBackofficeAxe.get('/form-data/vehicle-makes');
const backOfficeGetPrivacyTerms = () => quotationsBackofficeAxe.get('/form-data/data-privacy');
const backOfficeGetMunicipalities = () => quotationsBackofficeAxe.get('/form-data/communes');
const backOfficeGetFormData = () => quotationsBackofficeAxe.get('/form-data/service-models');
const getTravelStates = () => quotationsBackofficeAxe.get('/form-data/travel-states');

const getProfessions = () => quotationsBackofficeAxe.get('/form-data/professions');

const getVehicleActivities = () => quotationsBackofficeAxe.get('/form-data/vehicle-activities');

/**
 * Auto Form
 */

export const autoSubmitAnswers = async (
  answersData,
  navigate,
  requestToken,
) => {
  caller.autoFormDataUpdated({
    isSubmitting: true,
    loadingQuotes: true,
  });

  const res = await quotationsBackofficeAxe.post(
    `/quotations/vehicles/quote/${requestToken}`,
    answersData,
  );

  caller.autoFormDataUpdated({
    isSubmitting: false,
    loadingQuotes: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/auto/results`);
};

export const autoChangeIndex = async (newIndex) => {
  caller.autoFormDataUpdated({ index: newIndex });
};

export const autoGetInitialData = async () => {
  const [statesRes, brandsRes, formDataRes, dataPrivacyRes] = await Promise.all(
    [getStates(), getVehicleBrands(), getFormData(), getPrivacyTerms()],
  );

  caller.autoFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    brands: brandsRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.autoFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const motoGetInitialData = async () => {
  const [statesRes, brandsRes, formDataRes, dataPrivacyRes] = await Promise.all(
    [getStates(), getMotoBrands(), getFormData(), getPrivacyTerms()],
  );

  caller.motoFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    brands: brandsRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.motoFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const autoGetInitialDataBackOffice = async () => {
  const [statesRes, brandsRes, formDataRes, dataPrivacyRes] = await Promise.all(
    [
      backOfficeGetStates(),
      backOfficeGetVehicleBrands(),
      backOfficeGetFormData(),
      backOfficeGetPrivacyTerms(),
    ],
  );

  caller.autoFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    brands: brandsRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await backOfficeGetMunicipalities();

  caller.autoFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const autoUpdateFormData = (data) => {
  caller.autoFormDataUpdated(data);
};

export const autoGetVehicleModels = async (make_id, imm_vehicle_year) => {
  caller.autoFormDataUpdated({
    isLoadingVehicleModels: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/vehicle-models', {
    params: {
      make_id,
      imm_vehicle_year,
    },
  });
  caller.autoFormDataUpdated({
    isLoadingVehicleModels: false,
    vehicleModels: res.data.data,
  });
};

export const motoGetVehicleModels = async (make_id) => {
  caller.motoFormDataUpdated({
    isLoadingVehicleModels: true,
  });
  const res = await quotationsBackofficeAxe.get(
    `/form-data/get-moto-models/${make_id}`,
    {},
  );

  caller.motoFormDataUpdated({
    isLoadingVehicleModels: false,
    vehicleModels: res.data.data,
  });
};

export const motoGetVehicleVersions = async (model_id, imm_vehicle_year) => {
  caller.motoFormDataUpdated({
    isLoadingVehicleVersions: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/get-moto-version', {
    params: {
      model_id,
      imm_vehicle_year,
    },
  });
  caller.motoFormDataUpdated({
    isLoadingVehicleVersions: false,
  });
  if (res.status === 200) {
    caller.motoFormDataUpdated({
      vehicleVersions: res.data.data,
    });
  }
};

export const motoUpdateFormData = (data) => {
  caller.motoFormDataUpdated(data);
};

export const autoGetVehicleVersions = async (model_id, imm_vehicle_year) => {
  caller.autoFormDataUpdated({
    isLoadingVehicleVersions: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/vehicle-versions', {
    params: {
      model_id,
      imm_vehicle_year,
    },
  });
  caller.autoFormDataUpdated({
    isLoadingVehicleVersions: false,
  });
  if (res.status === 200) {
    caller.autoFormDataUpdated({
      vehicleVersions: res.data.data,
    });
  }
};

export const resetAutoForm = () => {
  caller.resetAutoForm();
};

/**
 * Autocarro Form
 */

export const autocarroSubmitAnswers = async (
  answersData,
  navigate,
  requestToken,
) => {
  caller.autocarroFormDataUpdated({
    isSubmitting: true,
    loadingQuotes: true,
  });

  const res = await quotationsBackofficeAxe.post(
    `/quotations/vehicles/quote/${requestToken}`,
    answersData,
  );

  caller.autocarroFormDataUpdated({
    isSubmitting: false,
    loadingQuotes: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/autocarro/results`);
};

export const autocarroChangeIndex = async (newIndex) => {
  caller.autocarroFormDataUpdated({ index: newIndex });
};

export const autocarroGetInitialData = async () => {
  const [
    statesRes,
    brandsRes,
    formDataRes,
    dataPrivacyRes,
    vehicleActivitiesRes,
  ] = await Promise.all([
    getStates(),
    getVehicleBrands(),
    getFormData(),
    getPrivacyTerms(),
    getVehicleActivities(),
  ]);

  caller.autocarroFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    brands: brandsRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
    vehicleActivities: vehicleActivitiesRes.data.data.map((act) => ({
      id: act.code,
      name: act.description,
    })),
  });

  const municipalitiesRes = await getMunicipalities();

  caller.autocarroFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const autocarroUpdateFormData = (data) => {
  caller.autocarroFormDataUpdated(data);
};

export const autocarroGetVehicleModels = async (make_id, imm_vehicle_year) => {
  caller.autocarroFormDataUpdated({
    isLoadingVehicleModels: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/vehicle-models', {
    params: {
      make_id,
      imm_vehicle_year,
    },
  });
  caller.autocarroFormDataUpdated({
    isLoadingVehicleModels: false,
    vehicleModels: res.data.data,
  });
};

export const autocarroGetVehicleVersions = async (
  model_id,
  imm_vehicle_year,
) => {
  caller.autocarroFormDataUpdated({
    isLoadingVehicleVersions: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/vehicle-versions', {
    params: {
      model_id,
      imm_vehicle_year,
    },
  });
  caller.autocarroFormDataUpdated({
    isLoadingVehicleVersions: false,
  });
  if (res.status === 200) {
    caller.autocarroFormDataUpdated({
      vehicleVersions: res.data.data,
    });
  }
};

export const resetAutocarroForm = () => {
  caller.resetAutocarroForm();
};

// Moto Form

export const motoSubmitAnswers = async (
  answersData,
  navigate,
  requestToken,
) => {
  caller.motoFormDataUpdated({
    isSubmitting: true,
    loadingQuotes: true,
  });

  const res = await quotationsBackofficeAxe.post(
    `/quotations/moto/quote/${requestToken}`,
    answersData,
  );

  caller.motoFormDataUpdated({
    isSubmitting: false,
    loadingQuotes: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/moto/results`);
};

export const motoChangeIndex = async (newIndex) => {
  caller.motoFormDataUpdated({ index: newIndex });
};

export const resetMotoForm = () => {
  caller.resetMotoForm();
};

/**
 * Profession Form
 */

export const professionGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes, professionsRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
    getProfessions(),
  ]);

  caller.professionFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
    professions: professionsRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.professionFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const professionUpdateFormData = (data) => {
  caller.professionFormDataUpdated(data);
};

export const professionSubmitAnswers = async (data, navigate, requestToken) => {
  caller.professionFormDataUpdated({
    loading: true,
  });

  const res = await quotationsBackofficeAxe.post(
    `/quotations/professions/quote/${requestToken}`,
    data,
  );
  navigate(
    `/backoffice/quote/${res.data.data.request_token}/profession/results`,
  );
};

export const resetProfessionForm = () => {
  caller.resetProfessionForm();
};

/**
 * Infortuni Form
 */

export const infortuniGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.infortuniFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.infortuniFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const infortuniUpdateFormData = (data) => {
  caller.infortuniFormDataUpdated(data);
};

export const infortuniChangeIndex = async (newIndex) => {
  caller.infortuniFormDataUpdated({ index: newIndex });
};

export const infortuniSubmitAnswers = async (data, navigate, requestToken) => {
  caller.infortuniFormDataUpdated({
    loading: true,
  });

  const res = await quotationsBackofficeAxe.post(
    `/quotations/infortuni/${requestToken}/quote`,
    data,
  );
  caller.infortuniFormDataUpdated({
    loading: false,
  });

  if (res.status !== 200) {
    generalAlertError('Something went wrong');
    return;
  }

  const token = res.data.data;
  navigate(`/backoffice/quote/${token}/infortuni/results`);
};

export const resetInfortuniForm = () => {
  caller.resetInfortuniForm();
};

/**
 * Travel Form
 */

export const travelGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.travelFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.travelFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });

  const travelStatesRes = await getTravelStates();

  caller.travelFormDataUpdated({
    travel_states: travelStatesRes.data.data,
  });
};

export const resetTravelForm = () => {
  caller.resetTravelForm();
};

export const travelUpdateFormData = (data) => {
  caller.travelFormDataUpdated(data);
};

export const travelSubmitAnswers = async (data, navigate, requestToken) => {
  caller.travelFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/travel/quote/${requestToken}`,
    data,
  );

  caller.travelFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/travel/results`);
};

/**
 * Salute Form
 */

export const saluteGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.saluteFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.saluteFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });

  // const travelStatesRes = await getTravelStates();

  // caller.saluteFormDataUpdated({
  //   travel_states: travelStatesRes.data.data,
  // });
};

export const resetSaluteForm = () => {
  caller.resetSaluteForm();
};

export const saluteUpdateFormData = (data) => {
  caller.saluteFormDataUpdated(data);
};

export const saluteSubmitAnswers = async (data, navigate, requestToken) => {
  caller.saluteFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/salute/quote/${requestToken}`,
    data,
  );

  caller.saluteFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/salute/results`);
};

/**
 * House Form
 */

export const homeGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.houseFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.houseFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const houseSubmitAnswers = async (data, navigate, requestToken) => {
  caller.houseFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(`/quotations/house/quote/${requestToken}`, data);

  caller.houseFormDataUpdated({
    loading: false,
  });

  if (res.status === 400) {
    generalAlertError(
      res.data.error.map((detail) => detail.message).join('\n'),
    );
    return;
  }

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  localStorage.setItem('UI_request', JSON.stringify(data));
  localStorage.setItem('SE_response', JSON.stringify(res.data));
  navigate(`/backoffice/quote/${res.data.request_token}/casa/results`);
};

export const resetHomeForm = () => {
  caller.resetHouseForm();
};

export const homeUpdateFormData = (data) => {
  caller.houseFormDataUpdated(data);
};

/**
 * Tutela Legale Form
 */

export const tutelaLegaleGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.tutelaLegaleFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.tutelaLegaleFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const tutelaLegaleFormReset = () => {
  caller.resetTutelaLegaleForm();
};

export const tutelaLegaleUpdateFormData = (data) => {
  caller.tutelaLegaleFormDataUpdated(data);
};

export const tutelaLegaleSubmitAnswers = async (data, navigate, requestToken) => {
  caller.tutelaLegaleFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/tutela-legale/quote/${requestToken}`,
    data,
  );

  caller.tutelaLegaleFormDataUpdated({
    loading: false,
  });

  if (!res.data.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.data.request_token}/tutela-legale/results`);
};

export const tutelaLegalePatenteMotorSubmitAnswers = async (data, navigate, requestToken) => {
  caller.tutelaLegaleFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/patente-motor/quote/${requestToken}`,
    data,
  );

  caller.tutelaLegaleFormDataUpdated({
    loading: false,
  });

  if (!res.data.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.data.request_token}/tutela-legale/results`);
};

export const tutelaLegaleNucleoFamigliareSubmitAnswers = async (data, navigate, requestToken) => {
  caller.tutelaLegaleFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/nucleo-famigliare/quote/${requestToken}`,
    data,
  );

  caller.tutelaLegaleFormDataUpdated({
    loading: false,
  });

  if (!res.data.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.data.request_token}/tutela-legale/results`);
};

export const tutelaLegaleProfessionalSubmitAnswers = async (data, navigate, requestToken) => {
  caller.tutelaLegaleFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/tutela-professionale/quote/${requestToken}`,
    data,
  );

  caller.tutelaLegaleFormDataUpdated({
    loading: false,
  });

  if (!res.data.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.data.request_token}/tutela-legale/results`);
};

/**
 * Sanitaria Stranieri Form
 */

export const sanitariaStranieriGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.sanitariaStranieriFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.sanitariaStranieriFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });

  // const travelStatesRes = await getTravelStates();

  // caller.saluteFormDataUpdated({
  //   travel_states: travelStatesRes.data.data,
  // });
};

export const resetSanitariaStranieriForm = () => {
  caller.resetSanitariaStranieriForm();
};

export const updateSanitariaStranieriFormData = (data) => {
  caller.sanitariaStranieriFormDataUpdated(data);
};

export const sanitariaStranieriSubmitAnswers = async (data, navigate, requestToken) => {
  caller.sanitariaStranieriFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/sanitaria-stranieri/quote/${requestToken}`,
    data,
  );

  caller.sanitariaStranieriFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/sanitaria-stranieri/results`);
};

/**
 * Ancillari Form
 */

export const ancillariGetInitialData = async () => {
  const [statesRes, brandsRes, formDataRes, dataPrivacyRes] = await Promise.all(
    [
      backOfficeGetStates(),
      backOfficeGetVehicleBrands(),
      backOfficeGetFormData(),
      backOfficeGetPrivacyTerms(),
    ],
  );

  caller.ancillariFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    brands: brandsRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.ancillariFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const resetAncillariForm = () => {
  caller.resetAncillariForm();
};

export const ancillariUpdateFormData = (data) => {
  caller.ancillariFormDataUpdated(data);
};

export const ancillariSubmitAnswers = async (data, navigate, requestToken) => {
  caller.ancillariFormDataUpdated({
    loadingQuotes: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/ancillari-auto/quote/${requestToken}`,
    data,
  );

  caller.ancillariFormDataUpdated({
    loadingQuotes: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/ancillari-auto/results`);
};

export const ancillariGetVehicleModels = async (make_id, imm_vehicle_year) => {
  caller.ancillariFormDataUpdated({
    isLoadingVehicleModels: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/vehicle-models', {
    params: {
      make_id,
      imm_vehicle_year,
    },
  });
  caller.ancillariFormDataUpdated({
    isLoadingVehicleModels: false,
    vehicleModels: res.data.data,
  });
};

export const ancillariGetVehicleVersions = async (model_id, imm_vehicle_year) => {
  caller.ancillariFormDataUpdated({
    isLoadingVehicleVersions: true,
  });
  const res = await quotationsBackofficeAxe.get('/form-data/vehicle-versions', {
    params: {
      model_id,
      imm_vehicle_year,
    },
  });
  caller.ancillariFormDataUpdated({
    isLoadingVehicleVersions: false,
  });
  if (res.status === 200) {
    caller.ancillariFormDataUpdated({
      vehicleVersions: res.data.data,
    });
  }
};

export const ancillariChangeIndex = async (newIndex) => {
  caller.ancillariFormDataUpdated({ index: newIndex });
};

/**
 * Malattia Form
 */

export const malattiaGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.malattiaFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.malattiaFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const resetMalattiaForm = () => {
  caller.resetMalattiaForm();
};

export const updateMalattiaFormData = (data) => {
  caller.malattiaFormDataUpdated(data);
};

export const malattiaSubmitAnswers = async (data, navigate, requestToken) => {
  caller.malattiaFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/malattia/quote/${requestToken}`,
    data,
  );

  caller.malattiaFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/malattia/results`);
};

/**
 * Public Employment Form
 */

export const publicEmploymentGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.publicEmploymentFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.publicEmploymentFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });

  // const travelStatesRes = await getTravelStates();

  // caller.saluteFormDataUpdated({
  //   travel_states: travelStatesRes.data.data,
  // });
};

export const resetPublicEmploymentForm = () => {
  caller.resetPublicEmploymentForm();
};

export const updatePublicEmploymentFormData = (data) => {
  caller.publicEmploymentFormDataUpdated(data);
};

export const publicEmploymentSubmitAnswers = async (data, navigate, requestToken) => {
  caller.publicEmploymentFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/public-employment/quote/${requestToken}`,
    data,
  );

  caller.publicEmploymentFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/pubblico-impiego/results`);
};

/**
 * Professione Sanita Form
 */

export const professioneSanitaGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.professioneSanitaFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.professioneSanitaFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });

  // const travelStatesRes = await getTravelStates();

  // caller.saluteFormDataUpdated({
  //   travel_states: travelStatesRes.data.data,
  // });
};

export const resetProfessioneSanitaForm = () => {
  caller.resetProfessioneSanitaForm();
};

export const updateProfessioneSanitaFormData = (data) => {
  caller.professioneSanitaFormDataUpdated(data);
};

export const professioneSanitaSubmitAnswers = async (data, navigate, requestToken) => {
  caller.professioneSanitaFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/professione-sanitarie/quote/${requestToken}`,
    data,
  );

  caller.professioneSanitaFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/rc-professionale-sanita/results`);
};

export const mediciDipendentiSubmitAnswers = async (data, navigate, requestToken) => {
  caller.professioneSanitaFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/medici-dipendenti/quote/${requestToken}`,
    data,
  );

  caller.professioneSanitaFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/rc-professionale-sanita/results`);
};

export const backOfficeCommercialInitialData = async () => {
  const [statesRes, dataPrivacyRes] = await Promise.all(
    [getStates(), getPrivacyTerms()],
  );
  const municipalitiesRes = await getMunicipalities();

  caller.commercialUpdated({
    loading: false,
    states: statesRes.data.data,
    municipalities: municipalitiesRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });
};

export const resetCommercialForm = () => {
  caller.resetCommercialForm();
};

export const commercialSubmitAnswers = async (
  answersData,
  navigate,
  requestToken,
) => {
  caller.commercialUpdated({
    isSubmitting: true,
    loadingQuotes: true,
  });

  const res = await quotationsBackofficeAxe.post(
    `/quotations/commercial/quote/${requestToken}`,
    answersData,
  );

  caller.commercialUpdated({
    isSubmitting: false,
    loadingQuotes: false,
  });

  if (!res.data.request_token) {
    const errorMessages = res.data.error
      ? res.data.message
      : "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema";
    generalAlertError(errorMessages);
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/commercial/results`);
};

export const mlpSubmitAnswersBackoffice = async (data, navigate, requestToken) => {
  caller.professioneSanitaFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(`/quotations/mlp/quote/${requestToken}`, data);

  caller.professioneSanitaFormDataUpdated({
    loading: false,
  });

  if (res.status === 400) {
    generalAlertError(
      res.data.error.map((detail) => detail.message).join('\n'),
    );
    return;
  }

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/rc-professionale-sanita/results`);
};

export const medicoProtettoSubmitAnswersBackoffice = async (data, navigate, requestToken) => {
  caller.professioneSanitaFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(`/quotations/medico-protetto/quote/${requestToken}`, data);

  caller.professioneSanitaFormDataUpdated({
    loading: false,
  });

  if (res.status === 400) {
    generalAlertError(
      res.data.error.map((detail) => detail.message).join('\n'),
    );
    return;
  }

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/rc-professionale-sanita/results`);
};

/**
 * Infortunio Form
 */

export const infortunioGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.infortunioFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.infortunioFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const resetInfortunioForm = () => {
  caller.resetInfortunioForm();
};

export const updateInfortunioFormData = (data) => {
  caller.infortunioFormDataUpdated(data);
};

export const infortunioSubmitAnswers = async (data, navigate, requestToken) => {
  caller.infortunioFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/infortunio/quote/${requestToken}`,
    data,
  );

  caller.infortunioFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/infortunio/results`);
};

/**
 * Condominio Form
 */

export const condominioGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.condominioFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.condominioFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const resetCondominioForm = () => {
  caller.resetCondominioForm();
};

export const updateCondominioFormData = (data) => {
  caller.condominioFormDataUpdated(data);
};

export const condominioSubmitAnswers = async (data, navigate, requestToken) => {
  caller.condominioFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/condominio/quote/${requestToken}`,
    data,
  );

  caller.condominioFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/condominio/results`);
};

/**
 * Rc Famiglia Form
 */

export const rcFamigliaGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.rcFamigliaFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.rcFamigliaFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const resetRcFamigliaForm = () => {
  caller.resetRcFamigliaForm();
};

export const updateRcFamigliaFormData = (data) => {
  caller.rcFamigliaFormDataUpdated(data);
};

export const rcFamigliaSubmitAnswers = async (data, navigate, requestToken) => {
  caller.rcFamigliaFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/rc-famiglia/quote/${requestToken}`,
    data,
  );

  caller.rcFamigliaFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/rc-famiglia/results`);
};

/**
 * Monopattini Form
 */

export const monopattiniGetInitialData = async () => {
  const [statesRes, formDataRes, dataPrivacyRes] = await Promise.all([
    getStates(),
    getFormData(),
    getPrivacyTerms(),
  ]);

  caller.monopattiniFormDataUpdated({
    loading: false,
    states: statesRes.data.data,
    formData: formDataRes.data.data,
    dataPrivacy: dataPrivacyRes.data.data,
  });

  const municipalitiesRes = await getMunicipalities();

  caller.monopattiniFormDataUpdated({
    municipalities: municipalitiesRes.data.data,
  });
};

export const resetMonopattiniaForm = () => {
  caller.resetMonopattiniForm();
};

export const updateMonopattiniFormData = (data) => {
  caller.monopattiniFormDataUpdated(data);
};

export const monopattiniSubmitAnswers = async (data, navigate, requestToken) => {
  caller.monopattiniFormDataUpdated({
    loading: true,
  });
  const res = await quotationsBackofficeAxe.post(
    `/quotations/monopattini-elettrici/quote/${requestToken}`,
    data,
  );

  caller.monopattiniFormDataUpdated({
    loading: false,
  });

  if (!res.data.request_token) {
    generalAlertError(
      "Qualcosa e' andato storto. Chiamare l'amministratore del Sistema",
    );
    return;
  }

  navigate(`/backoffice/quote/${res.data.request_token}/monopattini-elettrici/results`);
};
